import * as React from 'react';
import * as Highlight from 'react-highlighter';
import { ResultsCard } from 'utils/infosite-search-utils';

interface PropertyDetailsResultProps {
  card: ResultsCard;
  searchString: string;
  index: any;
}

export const PropertyDetailsResult: React.FunctionComponent<PropertyDetailsResultProps> = ({ card, searchString, index }) => {
  const { title, subTitle, body, paragraphView } = card;

  return (
    <article
      key={`property-details-card-${index}`}
      id={index}
      className="property-details-card uitk-card-separator-bottom all-y-padding-six"
    >
      <CardHeader title={title} subTitle={subTitle} searchString={searchString} />
      <section className="review-main all-t-padding-four">
        <div className="review-text uitk-type-300 pwa-theme--grey-600">
          <CardMatchingContent body={...body} searchString={searchString} paragraphView={paragraphView} />
        </div>
      </section>
    </article>
  );
};

PropertyDetailsResult.displayName = 'PropertyDetailsResult';

interface CardHeaderProps {
  title: string;
  subTitle: string;
  searchString: string;
}

const CardHeader: React.FunctionComponent<CardHeaderProps> = ({ title, subTitle, searchString }) => (
  <div className="uitk-type-display-300">
    {subTitle && (
      <React.Fragment>
        <span className="pwa-theme--grey-700">
          <Highlight search={searchString}>{title}</Highlight>
        </span>
        <span className="all-x-margin-one">/</span>
        <span className="pwa-theme--grey-900">
          <Highlight search={searchString}>{subTitle}</Highlight>
        </span>
      </React.Fragment>
    )}
    {!subTitle && (
      <span className="pwa-theme--grey-900">
        <Highlight search={searchString}>{title}</Highlight>
      </span>
    )}
  </div>
);

CardHeader.displayName = 'CardHeader';

interface CardMatchingContentProps {
  body: any;
  searchString: string;
  paragraphView: boolean;
}

const CardMatchingContent: React.FunctionComponent<CardMatchingContentProps> = ({ body, searchString, paragraphView }) => {
  if (body) {
    return body.map(
      (text, index) =>
        paragraphView ? (
          <p key={index}>
            <Highlight search={searchString}>{text}</Highlight>
          </p>
        ) : (
          <li key={index} className="uitk-type-300 pwa-theme--grey-700">
            <Highlight search={searchString}>{text}</Highlight>
          </li>
        )
    );
  }
};

CardMatchingContent.displayName = 'CardMatchingContent';
